import { addDoc, collection, deleteDoc, doc, getDoc, getDocs, updateDoc } from 'firebase/firestore';
import { db } from '../config/firebase';

const externalSourcesCollection = collection(db, "external_sources");

const externalSourcesService = { 
  getAll: async () => {
    try {  
      const externalSourcesSnapshot = await getDocs(externalSourcesCollection);
      const externalSourcesList = externalSourcesSnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      return externalSourcesList;
    } catch (error) {
      console.error('Error fetching external Sources:', error);
      throw error;
    }
  },
  add: async (externalSourcesData) => {
    try {
      const docRef = await addDoc(externalSourcesCollection, externalSourcesData);
      return docRef;
    } catch (error) {
      console.error('Error adding external sources:', error);
      throw error;
    }
  },
  edit: async ({ id, data }) => {
    try {
      const externalSourceRef = doc(db, 'external_sources', id);
      await updateDoc(externalSourceRef, data);
    } catch (error) {
      console.error('Error updating external Sources:', error);
      throw error;
    }
  },
  delete: async (externalSourceId) => {
    try {
     await deleteDoc(doc(db, "external_sources", externalSourceId));
     return true;
    } catch (error) {
      console.error('Error deleting external Sources:', error);
      throw error;
    }
  },

  getNameById: async (externalSourceId) => {
    try {
     const externalSourceRef = doc(db, 'external_sources', externalSourceId);
     const externalSourceSnap = await getDoc(externalSourceRef);

     if (externalSourceSnap.exists()) {
       return externalSourceSnap.data().name;  
     }
     else {
       return null; 
     }
    } 
    catch (error) {
      console.error('Error getting external source name:', error);
      throw error; 
    }
  },
};

export default externalSourcesService;